const tokens = {
  "colors.transparent": {
    "value": "transparent",
    "variable": "var(--colors-transparent)"
  },
  "colors.common.white": {
    "value": "#ffffff",
    "variable": "var(--colors-common-white)"
  },
  "colors.common.black": {
    "value": "#000",
    "variable": "var(--colors-common-black)"
  },
  "colors.grey.100": {
    "value": "#f7f7f7",
    "variable": "var(--colors-grey-100)"
  },
  "colors.grey.200": {
    "value": "#D8D9DA",
    "variable": "var(--colors-grey-200)"
  },
  "colors.grey.300": {
    "value": "#B1B3B5",
    "variable": "var(--colors-grey-300)"
  },
  "colors.grey.400": {
    "value": "#8B8C8F",
    "variable": "var(--colors-grey-400)"
  },
  "colors.grey.500": {
    "value": "#64666A",
    "variable": "var(--colors-grey-500)"
  },
  "colors.grey.800": {
    "value": "#262626",
    "variable": "var(--colors-grey-800)"
  },
  "colors.blues.focus": {
    "value": "#4B99E6",
    "variable": "var(--colors-blues-focus)"
  },
  "colors.blues.main": {
    "value": "#005FB9",
    "variable": "var(--colors-blues-main)"
  },
  "colors.blues.dark": {
    "value": "#02427E",
    "variable": "var(--colors-blues-dark)"
  },
  "colors.blues.darkest": {
    "value": "#02143A",
    "variable": "var(--colors-blues-darkest)"
  },
  "colors.blues.light": {
    "value": "#54A0E8",
    "variable": "var(--colors-blues-light)"
  },
  "colors.blues.lighter": {
    "value": "#9DCDFA",
    "variable": "var(--colors-blues-lighter)"
  },
  "colors.blues.lighter-2": {
    "value": "#C8E4FE",
    "variable": "var(--colors-blues-lighter-2)"
  },
  "colors.blues.lightest": {
    "value": "#EEF7FF",
    "variable": "var(--colors-blues-lightest)"
  },
  "colors.blues.extraLight": {
    "value": "#DEEFFF",
    "variable": "var(--colors-blues-extra-light)"
  },
  "colors.greens.main": {
    "value": "#008254",
    "variable": "var(--colors-greens-main)"
  },
  "colors.greens.extraLight": {
    "value": "#EFFCF8",
    "variable": "var(--colors-greens-extra-light)"
  },
  "colors.greens.light": {
    "value": "#E3FAF2",
    "variable": "var(--colors-greens-light)"
  },
  "colors.greens.lighter": {
    "value": "#B7ECDA",
    "variable": "var(--colors-greens-lighter)"
  },
  "colors.greens.lighter-2": {
    "value": "#81D6B8",
    "variable": "var(--colors-greens-lighter-2)"
  },
  "colors.greens.dark": {
    "value": "#006642",
    "variable": "var(--colors-greens-dark)"
  },
  "colors.greens.lightest": {
    "value": "#E3FAF2",
    "variable": "var(--colors-greens-lightest)"
  },
  "colors.greens.darkest": {
    "value": "#00482F",
    "variable": "var(--colors-greens-darkest)"
  },
  "colors.nwGreens.light": {
    "value": "#40AD87",
    "variable": "var(--colors-nw-greens-light)"
  },
  "colors.nwGreens.tintLP": {
    "value": "#A8EA4C",
    "variable": "var(--colors-nw-greens-tint-l-p)"
  },
  "colors.reds.main": {
    "value": "#DE2828",
    "variable": "var(--colors-reds-main)"
  },
  "colors.reds.dark": {
    "value": "#B40000",
    "variable": "var(--colors-reds-dark)"
  },
  "colors.reds.light": {
    "value": "#FF5D5E",
    "variable": "var(--colors-reds-light)"
  },
  "colors.reds.lighter": {
    "value": "#FF9090",
    "variable": "var(--colors-reds-lighter)"
  },
  "colors.reds.lightest": {
    "value": "#FFE8E8",
    "variable": "var(--colors-reds-lightest)"
  },
  "colors.reds.extraLight": {
    "value": "#FFF7F7",
    "variable": "var(--colors-reds-extra-light)"
  },
  "colors.yellows.main": {
    "value": "#FFC764",
    "variable": "var(--colors-yellows-main)"
  },
  "colors.yellows.dark": {
    "value": "#EFA92E",
    "variable": "var(--colors-yellows-dark)"
  },
  "colors.yellows.light": {
    "value": "#FBD083",
    "variable": "var(--colors-yellows-light)"
  },
  "colors.yellows.lighter": {
    "value": "#FFE2AE",
    "variable": "var(--colors-yellows-lighter)"
  },
  "colors.yellows.lighter-2": {
    "value": "#FFF0D6",
    "variable": "var(--colors-yellows-lighter-2)"
  },
  "colors.yellows.lightest": {
    "value": "#FFF7EA",
    "variable": "var(--colors-yellows-lightest)"
  },
  "colors.neutral.lightest": {
    "value": "#F5F5F5",
    "variable": "var(--colors-neutral-lightest)"
  },
  "colors.neutral.lighter": {
    "value": "#D8D9DA",
    "variable": "var(--colors-neutral-lighter)"
  },
  "colors.neutral.lighter-2": {
    "value": "#EBEBEC",
    "variable": "var(--colors-neutral-lighter-2)"
  },
  "colors.neutral.light": {
    "value": "#B1B3B5",
    "variable": "var(--colors-neutral-light)"
  },
  "colors.neutral.main": {
    "value": "#8B8C8F",
    "variable": "var(--colors-neutral-main)"
  },
  "colors.neutral.dark": {
    "value": "#64666A",
    "variable": "var(--colors-neutral-dark)"
  },
  "colors.neutral.darker": {
    "value": "#3D4045",
    "variable": "var(--colors-neutral-darker)"
  },
  "colors.neutral.darker-2": {
    "value": "#3D4045",
    "variable": "var(--colors-neutral-darker-2)"
  },
  "colors.neutral.darkest": {
    "value": "#000000",
    "variable": "var(--colors-neutral-darkest)"
  },
  "colors.lime.main": {
    "value": "#E2FF39",
    "variable": "var(--colors-lime-main)"
  },
  "colors.lime.tintLP": {
    "value": "#DDFA88",
    "variable": "var(--colors-lime-tint-l-p)"
  },
  "colors.lime.tintLP2": {
    "value": "#E8FDAC",
    "variable": "var(--colors-lime-tint-l-p2)"
  },
  "colors.lime.lightest": {
    "value": "#F8FFE4",
    "variable": "var(--colors-lime-lightest)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "1rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1.75rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "2.75rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "3rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "3.5rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "4rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "4.5rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.12": {
    "value": "6rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.16": {
    "value": "8rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "10rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "12rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.3.5": {
    "value": "1.5rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.content.0": {
    "value": "var(--spacing-0)",
    "variable": "var(--spacing-content-0)"
  },
  "spacing.content.1": {
    "value": "var(--spacing-1)",
    "variable": "var(--spacing-content-1)"
  },
  "spacing.content.2": {
    "value": "var(--spacing-2)",
    "variable": "var(--spacing-content-2)"
  },
  "spacing.content.3": {
    "value": "var(--spacing-3)",
    "variable": "var(--spacing-content-3)"
  },
  "spacing.content.4": {
    "value": "var(--spacing-4)",
    "variable": "var(--spacing-content-4)"
  },
  "spacing.content.5": {
    "value": "var(--spacing-5)",
    "variable": "var(--spacing-content-5)"
  },
  "spacing.content.3-half": {
    "value": "var(--spacing-3\\.5)",
    "variable": "var(--spacing-content-3-half)"
  },
  "spacing.content.0--wide": {
    "value": "var(--spacing-0)",
    "variable": "var(--spacing-content-0--wide)"
  },
  "spacing.content.1--wide": {
    "value": "var(--spacing-1)",
    "variable": "var(--spacing-content-1--wide)"
  },
  "spacing.content.2--wide": {
    "value": "var(--spacing-2)",
    "variable": "var(--spacing-content-2--wide)"
  },
  "spacing.content.3--wide": {
    "value": "var(--spacing-3)",
    "variable": "var(--spacing-content-3--wide)"
  },
  "spacing.content.3-half--wide": {
    "value": "var(--spacing-3\\.5)",
    "variable": "var(--spacing-content-3-half--wide)"
  },
  "spacing.content.4--wide": {
    "value": "var(--spacing-4)",
    "variable": "var(--spacing-content-4--wide)"
  },
  "spacing.content.5--wide": {
    "value": "var(--spacing-5)",
    "variable": "var(--spacing-content-5--wide)"
  },
  "fonts.gotham": {
    "value": "var(--font-gotham, Gotham), sans-serif",
    "variable": "var(--fonts-gotham)"
  },
  "fonts.gothamDisplay": {
    "value": "var(--font-gotham, GothamDisplay), sans-serif",
    "variable": "var(--fonts-gotham-display)"
  },
  "fonts.chronicleDisplay": {
    "value": "var(--font-chronicle-display, Chronicle Display), serif",
    "variable": "var(--fonts-chronicle-display)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--radii-none)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.5rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "1rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "1.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "4rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.half": {
    "value": "50%",
    "variable": "var(--radii-half)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "shadows.tooltip": {
    "value": "0 4px 8px 0 rgb(100 102 106 / 15%), 0 8px 16px 0 rgb(100 102 106 / 33%)",
    "variable": "var(--shadows-tooltip)"
  },
  "shadows.popover": {
    "value": "rgba(100, 102, 106, 0.1) 0px 4px 8px 0px, rgba(100, 102, 106, 0.36) 0px 1px 4px 0px",
    "variable": "var(--shadows-popover)"
  },
  "shadows.stickyBanner": {
    "value": "0 -10px 10px 0 rgba(100, 102, 106, 0.05)",
    "variable": "var(--shadows-sticky-banner)"
  },
  "shadows.dialog": {
    "value": "0px -4px 4px 0px #00000026",
    "variable": "var(--shadows-dialog)"
  },
  "shadows.subnav": {
    "value": "0px 3px 10px 0px #0000000D",
    "variable": "var(--shadows-subnav)"
  },
  "shadows.modal": {
    "value": "0 8px 36px 0 rgba(0, 0, 0, 0.16)",
    "variable": "var(--shadows-modal)"
  },
  "fontWeights.default": {
    "value": "400",
    "variable": "var(--font-weights-default)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "breakpoints.xs": {
    "value": "480px",
    "variable": "var(--breakpoints-xs)"
  },
  "breakpoints.sm": {
    "value": "768px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "1080px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1280px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1440px",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.xxl": {
    "value": "1576px",
    "variable": "var(--breakpoints-xxl)"
  },
  "breakpoints.2xl": {
    "value": "1920px",
    "variable": "var(--breakpoints-2xl)"
  },
  "sizes.breakpoint-xs": {
    "value": "480px",
    "variable": "var(--sizes-breakpoint-xs)"
  },
  "sizes.breakpoint-sm": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "1080px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1440px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-xxl": {
    "value": "1576px",
    "variable": "var(--sizes-breakpoint-xxl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1920px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "colors.text.primary": {
    "value": "var(--colors-common-black)",
    "variable": "var(--colors-text-primary)"
  },
  "colors.text.secondary": {
    "value": "var(--colors-grey-500)",
    "variable": "var(--colors-text-secondary)"
  },
  "colors.primary.dark": {
    "value": "var(--colors-greens-dark)",
    "variable": "var(--colors-primary-dark)"
  },
  "colors.primary.main": {
    "value": "var(--colors-greens-main)",
    "variable": "var(--colors-primary-main)"
  },
  "colors.primary.light": {
    "value": "var(--colors-nw-greens-light)",
    "variable": "var(--colors-primary-light)"
  },
  "colors.secondary.light": {
    "value": "var(--colors-blues-lightest)",
    "variable": "var(--colors-secondary-light)"
  },
  "colors.secondary.main": {
    "value": "var(--colors-blues-main)",
    "variable": "var(--colors-secondary-main)"
  },
  "colors.background.default": {
    "value": "var(--colors-common-white)",
    "variable": "var(--colors-background-default)"
  },
  "colors.background.paper": {
    "value": "var(--colors-common-white)",
    "variable": "var(--colors-background-paper)"
  },
  "colors.info.light": {
    "value": "var(--colors-yellows-lightest)",
    "variable": "var(--colors-info-light)"
  },
  "colors.info.dark": {
    "value": "var(--colors-yellows-dark)",
    "variable": "var(--colors-info-dark)"
  },
  "colors.info.main": {
    "value": "var(--colors-yellows-light)",
    "variable": "var(--colors-info-main)"
  },
  "colors.action.active": {
    "value": "rgba(0, 0, 0, 0.54)",
    "variable": "var(--colors-action-active)"
  },
  "colors.action.hover": {
    "value": "rgba(0,0,0,0.04)",
    "variable": "var(--colors-action-hover)"
  },
  "colors.action.disabled": {
    "value": "rgba(0, 0, 0, 0.26)",
    "variable": "var(--colors-action-disabled)"
  },
  "colors.action.disabledBackground": {
    "value": "rgba(0, 0, 0, 0.12)",
    "variable": "var(--colors-action-disabled-background)"
  },
  "colors.formControl.trim": {
    "value": "#b4b9c1",
    "variable": "var(--colors-form-control-trim)"
  },
  "colors.divider": {
    "value": "rgba(0, 0, 0, 0.12)",
    "variable": "var(--colors-divider)"
  },
  "sizes.icon.small": {
    "value": "1rem",
    "variable": "var(--sizes-icon-small)"
  },
  "sizes.icon.medium": {
    "value": "1.5rem",
    "variable": "var(--sizes-icon-medium)"
  },
  "sizes.icon.large": {
    "value": "2rem",
    "variable": "var(--sizes-icon-large)"
  },
  "sizes.icon.x-large": {
    "value": "2.75rem",
    "variable": "var(--sizes-icon-x-large)"
  },
  "sizes.icon.xx-large": {
    "value": "3.5rem",
    "variable": "var(--sizes-icon-xx-large)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.content.-0": {
    "value": "calc(var(--spacing-content-0) * -1)",
    "variable": "var(--spacing-content-0)"
  },
  "spacing.content.-1": {
    "value": "calc(var(--spacing-content-1) * -1)",
    "variable": "var(--spacing-content-1)"
  },
  "spacing.content.-2": {
    "value": "calc(var(--spacing-content-2) * -1)",
    "variable": "var(--spacing-content-2)"
  },
  "spacing.content.-3": {
    "value": "calc(var(--spacing-content-3) * -1)",
    "variable": "var(--spacing-content-3)"
  },
  "spacing.content.-4": {
    "value": "calc(var(--spacing-content-4) * -1)",
    "variable": "var(--spacing-content-4)"
  },
  "spacing.content.-5": {
    "value": "calc(var(--spacing-content-5) * -1)",
    "variable": "var(--spacing-content-5)"
  },
  "spacing.content.-3-half": {
    "value": "calc(var(--spacing-content-3-half) * -1)",
    "variable": "var(--spacing-content-3-half)"
  },
  "spacing.content.-0--wide": {
    "value": "calc(var(--spacing-content-0--wide) * -1)",
    "variable": "var(--spacing-content-0--wide)"
  },
  "spacing.content.-1--wide": {
    "value": "calc(var(--spacing-content-1--wide) * -1)",
    "variable": "var(--spacing-content-1--wide)"
  },
  "spacing.content.-2--wide": {
    "value": "calc(var(--spacing-content-2--wide) * -1)",
    "variable": "var(--spacing-content-2--wide)"
  },
  "spacing.content.-3--wide": {
    "value": "calc(var(--spacing-content-3--wide) * -1)",
    "variable": "var(--spacing-content-3--wide)"
  },
  "spacing.content.-3-half--wide": {
    "value": "calc(var(--spacing-content-3-half--wide) * -1)",
    "variable": "var(--spacing-content-3-half--wide)"
  },
  "spacing.content.-4--wide": {
    "value": "calc(var(--spacing-content-4--wide) * -1)",
    "variable": "var(--spacing-content-4--wide)"
  },
  "spacing.content.-5--wide": {
    "value": "calc(var(--spacing-content-5--wide) * -1)",
    "variable": "var(--spacing-content-5--wide)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.white": {
    "value": "var(--colors-color-palette-white)",
    "variable": "var(--colors-color-palette-white)"
  },
  "colors.colorPalette.black": {
    "value": "var(--colors-color-palette-black)",
    "variable": "var(--colors-color-palette-black)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--colors-color-palette-focus)",
    "variable": "var(--colors-color-palette-focus)"
  },
  "colors.colorPalette.main": {
    "value": "var(--colors-color-palette-main)",
    "variable": "var(--colors-color-palette-main)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--colors-color-palette-dark)",
    "variable": "var(--colors-color-palette-dark)"
  },
  "colors.colorPalette.darkest": {
    "value": "var(--colors-color-palette-darkest)",
    "variable": "var(--colors-color-palette-darkest)"
  },
  "colors.colorPalette.light": {
    "value": "var(--colors-color-palette-light)",
    "variable": "var(--colors-color-palette-light)"
  },
  "colors.colorPalette.lighter": {
    "value": "var(--colors-color-palette-lighter)",
    "variable": "var(--colors-color-palette-lighter)"
  },
  "colors.colorPalette.lighter-2": {
    "value": "var(--colors-color-palette-lighter-2)",
    "variable": "var(--colors-color-palette-lighter-2)"
  },
  "colors.colorPalette.lightest": {
    "value": "var(--colors-color-palette-lightest)",
    "variable": "var(--colors-color-palette-lightest)"
  },
  "colors.colorPalette.extraLight": {
    "value": "var(--colors-color-palette-extra-light)",
    "variable": "var(--colors-color-palette-extra-light)"
  },
  "colors.colorPalette.tintLP": {
    "value": "var(--colors-color-palette-tint-l-p)",
    "variable": "var(--colors-color-palette-tint-l-p)"
  },
  "colors.colorPalette.darker": {
    "value": "var(--colors-color-palette-darker)",
    "variable": "var(--colors-color-palette-darker)"
  },
  "colors.colorPalette.darker-2": {
    "value": "var(--colors-color-palette-darker-2)",
    "variable": "var(--colors-color-palette-darker-2)"
  },
  "colors.colorPalette.tintLP2": {
    "value": "var(--colors-color-palette-tint-l-p2)",
    "variable": "var(--colors-color-palette-tint-l-p2)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--colors-color-palette-secondary)",
    "variable": "var(--colors-color-palette-secondary)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.paper": {
    "value": "var(--colors-color-palette-paper)",
    "variable": "var(--colors-color-palette-paper)"
  },
  "colors.colorPalette.active": {
    "value": "var(--colors-color-palette-active)",
    "variable": "var(--colors-color-palette-active)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.disabledBackground": {
    "value": "var(--colors-color-palette-disabled-background)",
    "variable": "var(--colors-color-palette-disabled-background)"
  },
  "colors.colorPalette.trim": {
    "value": "var(--colors-color-palette-trim)",
    "variable": "var(--colors-color-palette-trim)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar